import { lazy, Suspense } from 'react'

import Helmet from 'react-helmet'
import { useSelector } from 'react-redux'

import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'
import { useProcurifyIntl } from '@webapp/hooks'
import { type BudgetCategoryDetails } from '@webapp/models'
import messages from './messages'

export const BUDGET_CATEGORY_EDIT_PAGE = '/settings/budget-categories/edit'
export const BUDGETS_EDIT_PAGE = '/settings/budgets/edit'

const BudgetCategoryEditChunk = lazy(() =>
  import('../containers/BudgetCategoryUpsertView').then(
    ({ BudgetCategoryUpsertView }) => ({
      default: BudgetCategoryUpsertView,
    })
  )
)

export interface IBudgetEditPageProps {}

export interface BudgetsEditPageParams {
  uuid: BudgetCategoryDetails['uuid']
}

export const BudgetCategoryEditPage = () => {
  const intl = useProcurifyIntl()
  const { enable_flexible_spend_tracking: isFlexibleSpendTrackingEnabled } =
    useSelector(makeSelectFeatureSwitches())

  return (
    <Suspense fallback={null}>
      <Helmet>
        <title>
          Procurify |{' '}
          {intl.formatMessage(
            isFlexibleSpendTrackingEnabled
              ? messages.editBudgetTitle
              : messages.editBudgetCategoryTitle
          )}
        </title>
      </Helmet>
      <BudgetCategoryEditChunk isEdit />
    </Suspense>
  )
}
